import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface IMultipleChoice {
  value: string | number;
  label: string;
}

@Component({
  selector: 'g-multiple-select',
  templateUrl: './g-multiple-select.component.html',
  styleUrls: ['./g-multiple-select.component.scss']
})
export class GMultipleSelectComponent implements OnInit {
  @Input() public control: FormControl;
  @Input() public choices: IMultipleChoice[];
  @Input() public title: string;
  @Input() public type?: string;
  @Output() public change = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }
}
